// Generated at build time from package.json — do not edit.
export const APP_VERSION = '13.1.24';
